import { BaseService } from 'services/baseService';
import { RoleModel } from 'types/models/RoleModel';

class RoleService extends BaseService<RoleModel> {
  controllerName = 'role';
}

export const roleService = new RoleService();
